import type { PropsWithChildren } from "react";
import { useAuth } from "../../auth/AuthProvider";

type AdminLayoutProps = PropsWithChildren<{
  title: string;
  subtitle: string;
}>;

export function AdminLayout({
  children,
  title,
  subtitle,
}: AdminLayoutProps) {
  const auth = useAuth();

  return (
    <div className="admin-app">
      <header className="admin-topbar">
        <div className="admin-topbar__inner">
          <div className="admin-topbar__brand">
            <span className="admin-topbar__mark" aria-hidden="true">
              RV
            </span>
            <div>
              <strong>Registro visitatori</strong>
              <span>Area amministrativa</span>
            </div>
          </div>
          <div className="admin-topbar__actions">
            <div className="admin-user-chip">
              <strong>{auth.profile?.fullName ?? "Admin"}</strong>
              <span>{auth.profile?.email ?? auth.session?.user.email}</span>
            </div>
            <button
              className="ghost-button ghost-button--sm"
              type="button"
              onClick={() => auth.signOut()}
            >
              Logout
            </button>
          </div>
        </div>
      </header>
      <main className="admin-main">
        <header className="admin-page-header">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </header>
        {children}
      </main>
    </div>
  );
}
